class PasswordChecker {
	constructor(parent) {
		this.input = parent.querySelector("input")
		this.button = parent.querySelector(".form_password-btn")

		this.button.addEventListener("click", (e) => {
			e.preventDefault()

			this.showPassword()
		})
	}

	showPassword() {
		this.input.type = "password" === this.input.type ? "text" : "password"
		this.button.classList.toggle("show")
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const passwordFields = document.querySelectorAll(".form_row.password")

	if (passwordFields) {
		passwordFields.forEach(passwordField => {
			new PasswordChecker(passwordField)
		})
	}
})
